import {OriginalRevenueRenewalIncreaseType} from "../../../../__generated__/generated_types";

export function renewalIncreaseTypePrettyName(val: OriginalRevenueRenewalIncreaseType | "manual-entry"): string {
    let ret = "Manual Entry";
    if (val === OriginalRevenueRenewalIncreaseType.MarketOrInPlaceRent) {
        ret = "Grow In Place Rent";
    } else if (val === OriginalRevenueRenewalIncreaseType.MarketRentDiscount) {
        ret = "Discount From Market";
    } else if(val === OriginalRevenueRenewalIncreaseType.MarkToMarketOrInPlaceRent) {
        ret = "Grow IPR or Mark to Market";
    } else if(val === OriginalRevenueRenewalIncreaseType.CustomRenewalIncrease) {
        ret = "Custom Formula";
    }
    return ret;
}
